<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("contracts") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <div class="d-flex justify-start align-center mb-3">
            <CustomSelect
              dense
              solo
              custom-selection
              custom-item
              :value="visibleHeaders"
              multiple
              @input="setHeader"
              item-text="text"
              item-value="value"
              :items="headers"
              class="user_input no-margin mt-1"
            >
              <template #item="{ attrs, item }">
                <div
                  class="column-setting-title-wrap flex-grow-1"
                  @click="changeColumnSettings(item, attrs)"
                >
                  <BaseCheckbox
                    class="mr-2"
                    v-model="visibleHeaders"
                    :value="item.value"
                  />
                  <span class="v-list-item__title" style="width: 100%">{{
                    item.text
                  }}</span>
                </div>
              </template>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ $t("columns") }}</span>
              </template>
            </CustomSelect>
            <VBtn
              color="primary"
              dark
              class="ml-2"
              min-height="38"
              v-if="permissions.CONTRACT_CREATE"
              @click="$refs.contractFormObs.open('create')"
            >
              <vue-icon class="mr-2" icon="contractIcon"></vue-icon>
              {{ $t("create") }}
            </VBtn>
          </div>
          <div id="custom__table" class="mobile_simple overflow-auto">
            <TableWithFilter
              @change-header-order="onChangeHeaderOrder"
              @table-header-resized="onChangeSizeHeader"
              is-enabled-orderable-table
              isEnabledResizeTable
              :child-key="contractChildKey"
              :headers="filterableHeadersTable"
              :items="items"
              :options="tableOptions"
              fixed-header
              handlerValue="code"
              @update:sort="getContractsBySort"
              :page="configuration.page"
            >
              <template #expandBtn="{ openHandler, item }">
                <TriangleBtn
                  :active="item.show"
                  :loading="item.loading"
                  @click="openHandler(item)"
                />
              </template>
              <!-- parent -->
              <template #item.conclusionDate="{ item }"
                >{{ item.conclusionDate | dateParse }}
              </template>
              <template #item.guessReceiveDate="{ item }">
                {{ item["guessReceiveDate"] | dateParse }}
              </template>
              <template #item.state="{ item }">
                <span
                  :style="{ color: item.statusColour }"
                  class="font-weight-bold"
                  >{{ $t(`contractStatus.${item.state}`) }}</span
                >
              </template>
              <template #item.action="{ item, index }">
                <VTooltip
                  v-if="
                    contractStatus.CONTRACT_CONCLUTION === item.state &&
                    permissions.CONTRACT_ITEM_CREATE
                  "
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="$refs.contractEditDialog.open(item)"
                    >
                      <vue-icon icon="newPencilIcon" />
                    </VBtn>
                  </template>
                  <span>{{ $t("edit") }}</span>
                </VTooltip>
                <VTooltip color="#fff" left nudge-right="10" nudge-top="35">
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      @click="openViewDialog(item.id)"
                      class="new_style"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <VueIcon icon="newEyeIcon"></VueIcon>
                    </VBtn>
                  </template>
                  <span>{{ $t("viewContractDetails") }}</span>
                </VTooltip>

                <VBtn
                  v-if="$store.getters.isUserAdmin"
                  @click="$refs.contractHistoryDialog.open(item.id)"
                  class="new_style"
                  :title="$tc('contractHistory', 1)"
                >
                  <VueIcon icon="newTimeIcon"></VueIcon>
                </VBtn>
                <VTooltip
                  v-if="
                    contractStatus.CONTRACT_CONCLUTION === item.state &&
                    permissions.CONTRACT_ITEM_CREATE
                  "
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="$refs.contractFormObs.open('add', null, item)"
                    >
                      <VueIcon icon="newPlusIcon" />
                    </VBtn>
                  </template>
                  <span>{{ $t("addPosition") }}</span>
                </VTooltip>
                <VTooltip
                  v-if="permissions.CONTRACT_AGGREMENT_FILE_ADD"
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="
                        $refs.ozlContractDocumentDialog.open({
                          documents: item.aggrementFiles,
                          id: item.id,
                          index,
                        })
                      "
                    >
                      <vue-icon icon="newTextBoxPlus" />
                    </VBtn>
                  </template>
                  <span>{{ $t("contractDocuments") }}</span>
                </VTooltip>
                <VTooltip
                  v-if="
                    contractStatus.CONTRACT_CONCLUTION === item.state &&
                    permissions.ORDER_ITEM_STATUS_REJECT_OZL
                  "
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="
                        terminateContractDialogOpenHandler('contract', item)
                      "
                    >
                      <VueIcon icon="newCancelIcon"></VueIcon>
                    </VBtn>
                  </template>
                  <span>{{ $t("terminate") }}</span>
                </VTooltip>
                <Downloader
                  v-if="item['productResourceLink']"
                  :address="item['productResourceLink']"
                  :file-name="item['productResourceName']"
                ></Downloader>
                <!--                <VBtn-->
                <!--                  v-if="$store.getters.isUserAdmin"-->
                <!--                  class="new_style"-->
                <!--                  @click="deleteContract(item.id)"-->
                <!--                >-->
                <!--                  <vue-icon icon="newTrashIcon" />-->
                <!--                </VBtn>-->
              </template>
              <template #item.conclusionDate="{ item }"
                >{{ item["conclusionDate"] | dateParse }}
              </template>
              <template
                #item.rejectReasen="{
                  item,
                  /**
                   * @type Object
                   * @property rejectResourceLink
                   * @property rejectReason
                   */
                }"
              >
                <Downloader
                  v-if="item['rejectResourceLink']"
                  :address="item.rejectResourceLink"
                  :file-name="item.rejectReason"
                >
                  <template #default="{ downloadFile }">
                    <a
                      class="text-decoration-underline"
                      @click.prevent="downloadFile"
                      >{{ item.rejectReason }}</a
                    >
                  </template>
                </Downloader>
              </template>
              <template #item.receiverDate="{ item }"
                >{{ item["actualReceiveDate"] | dateParse }}
              </template>
              <!-- child -->
              <template #child.numb="{ child }">{{ child.numb }}</template>
              <template #child.orderNumb="{ child }"
                >{{ child.orderNumb ? `${child.orderNumb}` : "-" }}
              </template>

              <template
                #child.itemNumb="{
                  /**
                   * @type Object
                   * @property orderItemNumb
                   * @property stateColur
                   */
                  child,
                }"
                >{{ child.orderItemNumb ? `${child.orderItemNumb}` : "-" }}
              </template>
              <template #child.state="{ child }">
                <span
                  class="font-weight-bold"
                  :style="{ color: child.stateColur }"
                  >{{ $t(`contractStatus.${child.state}`) }}</span
                >
              </template>
              <template #child.guessReceiveDate="{ child }">
                {{ child["itemGuessReceiveDate"] | dateParse }}
              </template>
              <template
                #child.action="{
                  /**
                   * @type {Object}
                   * @property {string} id
                   */
                  child,
                  item,
                }"
              >
                <VTooltip
                  v-if="permissions.CONTRACT_CHANGE_STATE"
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="
                        $refs.ozlContractItemChangeStatusDialog.open({
                          id: child.id,
                          code: item.code,
                          numb: child.numb,
                          state: child.state,
                        })
                      "
                    >
                      <VueIcon icon="newCogIcon"></VueIcon>
                    </VBtn>
                  </template>
                  <span>{{ $t("edit") }}</span>
                </VTooltip>
                <VTooltip
                  v-if="
                    child.state === contractItemStatus.NEW &&
                    permissions.CONTRACT_CREATE
                  "
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="$refs.contractFormObs.open('edit', child, item)"
                    >
                      <vue-icon icon="newPencilIcon" />
                    </VBtn>
                  </template>
                  <span>{{ $t("edit") }}</span>
                </VTooltip>
                <VTooltip
                  v-if="
                    contractStatus.CONTRACT_CONCLUTION === item.state &&
                    $can($permissions['CONTRACT_CREATE'])
                  "
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      @click="
                        $refs.ozlNotificationToOmtk.open(child.id, {
                          contractNumber: item.code,
                          productName: child.productName,
                        })
                      "
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                    >
                      <vue-icon icon="bellIcon" />
                    </VBtn>
                  </template>
                  <span>{{ $t("sendNotification") }}</span>
                </VTooltip>
                <VTooltip
                  v-if="
                    contractStatus.CONTRACT_CONCLUTION === item.state &&
                    permissions.CONTRACT_ITEM_DELETE
                  "
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="deleteContractHandler(child)"
                    >
                      <vue-icon icon="newTrashIcon" />
                    </VBtn>
                  </template>
                  <span>{{ $t("delete") }}</span>
                </VTooltip>
                <MultipleDownloader
                  v-if="child['orderResources']"
                  :files="child['orderResources']"
                />
                <VBtn @click="openChildViewDialog(child)" class="new_style">
                  <VueIcon icon="newEyeIcon"></VueIcon>
                </VBtn>
              </template>
              <!-- parent -->
              <template #item.conclusionDate="{ item }"
                >{{ item["conclusionDate"] | dateParse }}
              </template>
              <template #item.receiverDate="{ item }"
                >{{ item["actualReceiveDate"] | dateParse }}
              </template>
              <template #item.supplyType="{ item }"
                >{{
                  item.supplyType
                    ? item.supplyType[`name_${$i18n.locale}`]
                    : "-"
                }}
              </template>
              <template #child.productTypeName="{ child }"
                >{{
                  child.productCategory
                    ? child.productCategory[`name_${$i18n.locale}`]
                    : "-"
                }}
              </template>
              <!-- <template #item.supplierName="{ item }"
                >{{ item.supplier.name }}
              </template> -->
              <!-- child -->
              <template #child.numb="{ child }">{{ child.numb }}</template>
              <template #child.orderNumb="{ child }"
                >{{ child.orderNumb ? `${child.orderNumb}` : "-" }}
              </template>
              <template #child.itemNumb="{ child }"
                >{{ child.orderItemNumb ? `${child.orderItemNumb}` : "-" }}
              </template>
              <template #child.guessReceiveDate="{ child }">
                {{ child["itemGuessReceiveDate"] | dateParse }}
              </template>
              <template #child.unitType="{ child }"
                >{{ child[`unit_type_name_${$i18n.locale}`] }}
              </template>
              <template #child.count="{ child }"
                >{{ child.count | numberParse }}
              </template>
              <template #child.productAttrs="{ child }">
                {{ child.productAttrs && child.productAttrs.join(" || ") }}
              </template>
              <template #append:child="{ item }">
                <tr v-if="item.itemsPageCount > 1">
                  <td :colspan="filterableHeadersTable.length">
                    <div class="d-flex">
                      <VuePagination
                        @input="(page) => onChangeItemPage({ page, item })"
                        :length="item.itemsPageCount"
                        v-model="item.itemsCurrentPage"
                      ></VuePagination>
                    </div>
                  </td>
                </tr>
              </template>
            </TableWithFilter>
          </div>
          <VuePagination
            go-to
            @update:limit="
              (limit) => {
                configuration.limit = limit;
                configuration.page = 1;
                changePage();
              }
            "
            v-model="configuration.page"
            :length="lastPage"
            @input="changePage"
            :limit="configuration.limit"
          />

          <ContractFormDialog
            ref="contractFormObs"
            v-model="contractDialog"
            @update-contracts="getContracts"
          />
          <VDialog
            v-model="dialogTerminate"
            class="user_modal_dialog"
            max-width="600px"
          >
            <ValidationObserver ref="rejectFormObs" v-slot="{ handleSubmit }">
              <Form @submit.prevent="handleSubmit(terminateContract)">
                <VCard>
                  <VCardTitle class="mb-5">
                    <span class="headline title_modal_user">{{
                      $t("contractTerminated")
                    }}</span>
                    <VIcon
                      class="info_modal_close"
                      @click="dialogTerminate = false"
                      >mdi-close
                    </VIcon>
                  </VCardTitle>
                  <VCardText class="main_modal">
                    <CustomInputText
                      v-model="rejectFormData.reason"
                      :label="$t('contractRejectionHint')"
                      :rules="`required_custom_message:${$t(
                        'validation.required_reject'
                      )}`"
                      autofocus
                      class="col-lg-12 pa-0 user_input"
                    ></CustomInputText>
                  </VCardText>
                  <VCardActions class="footer_modal_user">
                    <div class="row">
                      <div
                        class="col-xs-6 pt-0 pb-0 ml-3 file_input_modal_add_ozl"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('file')"
                          rules="required|document|not_empty_file"
                        >
                          <VFileInput
                            v-model="rejectFormData.file"
                            :error-messages="errors[0]"
                            :label="$t('attachFile') + '*'"
                          ></VFileInput>
                        </ValidationProvider>
                      </div>
                      <div
                        class="d-flex flex-wrap justify-space-around button_modal_add mr-3 mt-3"
                      >
                        <VBtn color="#EE6565" dark type="submit"
                          >{{ $t("terminate") }}
                        </VBtn>
                      </div>
                    </div>
                  </VCardActions>
                </VCard>
              </Form>
            </ValidationObserver>
          </VDialog>
        </div>
      </div>
    </div>
    <WarningDialog
      ref="deleteDialog"
      v-model="deleteDialog"
      @apply="deleteContractConfirmHandler"
    ></WarningDialog>
    <OzlContractDocumentDialog
      ref="ozlContractDocumentDialog"
      @updated-files="
        ({ index, documents }) => (this.items[index].aggrementFiles = documents)
      "
    />
    <OzlNotificationToOmtk ref="ozlNotificationToOmtk" />
    <OzlContractDialogView ref="ozlViewDialog" />
    <OzlContractEditDialog @saved="getContracts" ref="contractEditDialog" />
    <ContractHistoryDialog ref="contractHistoryDialog" />
    <OzlContractItemChangeStatusDialog
      @changed="getContracts"
      ref="ozlContractItemChangeStatusDialog"
    />
    <OzlChildViewDialog
      ref="ozlChildViewDialog"
      @ozlDecided="$refs.confirmKeyDialogRef.refreshList()"
    ></OzlChildViewDialog>
  </div>
</template>

<script>
import TriangleBtn from "@/components/table-with-children/triangleBtn";
import {
  contractItemStatus,
  contractStatus,
  dateFormat,
  deliveryTypes,
  TABLES,
} from "@/utils/constants";
import moment, { locale } from "moment";
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import {
  debounce,
  getQueryByKey,
  makerPagination,
  trueSet,
} from "@/utils/pureFunctions";
import Downloader from "@/components/ui/downloader";
import MultipleDownloader from "@/components/ui/MultipleDownloader";
import ContractFormDialog from "@/components/ozl/ContractFormDialog";
import SocketService from "@/services/SocketService";
import { ozlContractSocketService } from "@/utils/socket/ozlContract";
import OzlContractDocumentDialog from "@/components/ozl/ContractDocumentDialog";
import OzlNotificationToOmtk from "@/components/ozl/NotificationToOmtk";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
// import VueSelect from "@/components/ui/vue-select/VueSelect";
import BaseCheckbox from "@/components/ui/BaseCheckbox";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import OzlContractDialogView from "@/components/ozl/OzlContractDialogView";
import gridTableMixin from "@/configuration/mixins/gridTableMixin";
import OzlContractEditDialog from "@/components/ozl/OzlContractEditDialog";
import ContractHistoryDialog from "@/components/ozl/ContractHistoryDialog";
import OzlContractItemChangeStatusDialog from "@/components/ozl/OzlContractItemChangeStatusDialog.vue";
import OzlChildViewDialog from "@/components/ozl/OzlChildViewDialog";
import i18n from "../../../plugins/I18n";
// import ConfirmKeyDialog from "@/components/ConfirmKeyDialog.vue";

const FilterOzlOrders = {
  code: null,
  fromDate: null,
  groupId: null,
  inisator: null,
  productName: null,
  status: null,
  supplierId: null,
  supplierType: null,
  toDate: null,
  typeId: null,
  requestNumber: null,
};
const ITEM_LIMIT = 200;

export default {
  data() {
    return {
      suppliers: [],
      productTypes: [],
      tableType: "Contract",
      contractChildKey: "items",
      items: [],
      deleteDialog: false,
      contractDialog: false,
      dialogTerminate: false,
      permissions: {},
      users: [],
      isShowFilter: false,
      contractListFilter: {
        ...FilterOzlOrders,
      },
      tableOptions: {
        sortBy: "conclusionDate",
        sortDirection: true,
        forOzl: false,
      },
      rejectFormData: {
        contractId: null,
        file: null,
        reason: "",
      },
      configuration: {
        total: 0,
        limit: 10,
        page: 1,
      },
      lastPage: 0,
      warehouses: [],
      productInputLoading: true,
      deleteContractItemParent: null,
      contractItemStatus,
      deleteItemId: null,
    };
  },
  watch: {
    dialogTerminate(val) {
      if (!val) {
        const { rejectFormObs } = this.$refs;
        this.rejectFormData = {
          reason: null,
          contractId: null,
          file: null,
        };
        if (rejectFormObs) rejectFormObs.reset();
      }
    },
  },
  computed: {
    deliveryTypes() {
      return [...deliveryTypes].map((item) => {
        return { ...item, name: this.$t(item.name) };
      });
    },
    deliveryTypesIndex() {
      return deliveryTypes.reduce((init, item) => {
        init[item["value"]] = item;
        return init;
      }, {});
    },
    filterableHeadersTable() {
      return this.headers.filter((item) => {
        return this.visibleHeaders.includes(item.value);
      });
    },
    contractStatus: () => contractStatus,
    contractStatusList() {
      return Object.keys(contractStatus).map((item) => {
        return {
          name: this.$t(`contractStatus.${item}`),
          id: item,
        };
      });
    },
  },
  methods: {
    i18n() {
      return i18n;
    },
    locale,
    setProductType(productTypes) {
      this.productTypes = productTypes;
    },
    setSupplier(suppliers) {
      this.suppliers = suppliers;
    },
    onChangeHandler: debounce(function () {
      let filter = { ...this.contractListFilter };
      if (filter.fromDate)
        filter.fromDate = moment(filter.fromDate).format(dateFormat);
      if (filter.toDate)
        filter.toDate = moment(filter.toDate).format(dateFormat);
      this.getContractsByFilter();
    }, 500),
    setHeader(headers) {
      this.visibleHeaders = headers;
    },
    /**
     * @typedef Param {Object}
     * @property page {Number}
     * @property item {Object}
     * @param param {Object<Param>}
     */
    async onChangeItemPage(param) {
      const page = param.page - 1;
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get("contract/list-item", {
          params: {
            contractId: param.item.id,
            limit: ITEM_LIMIT,
            page,
          },
        });
        param.item.items = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    openViewDialog(itemId) {
      // const { ozlViewDialog } = this.$refs;
      // if (ozlViewDialog) {
      //   ozlViewDialog.open({ items: item });
      // }
      // this.viewData = item;
      this.$router.push({
        name: "ozl-contracts-view",
        params: { id: itemId },
      });
    },
    openChildViewDialog(child) {
      const { ozlChildViewDialog } = this.$refs;
      if (ozlChildViewDialog) {
        ozlChildViewDialog.open({
          ...child,
          unitTypeName: child[`unit_type_name_${this.$i18n.locale}`],
        });
      }
    },
    async deleteContract(id) {
      if (confirm(this.$t("wantDeleteHint").toString())) {
        this.showLoading();
        try {
          await this.$http.delete("backend/contract-delete-permanently", {
            params: { id },
          });
          await this.getContracts();
          this.setSuccess({ text: this.$t("successfullyDeleted") });
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.clearLoading();
        }
      }
    },
    async changeColumnSettings(item, attr) {
      try {
        await this.$store.dispatch("updateColumn", {
          columnName: item.value,
          table: TABLES["Contract"].slug,
          visible: !trueSet(attr["aria-selected"]),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    deleteContractHandler(child) {
      this.deleteItemId = child.id;
      this.deleteDialog = true;
    },
    async getContractsBySort() {
      const { query: initialQuery } = this.$route;
      await this.$router.replace({
        query: { ...initialQuery, ...this.tableOptions },
      });
      this.showLoading();
      await this.getContracts();
      this.clearLoading();
    },
    async deleteContractConfirmHandler() {
      this.showLoading();
      try {
        await this.$http.delete("contract/delete-item", {
          data: {
            objectId: this.deleteItemId,
            reason: "Reject",
          },
        });
        this.deleteDialog = false;
        await this.getContracts();
        this.deleteItemId = null;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    terminateContractDialogOpenHandler(type, item, parent) {
      if (type === "contract") {
        this.rejectFormData.contractId = item.id;
        this.deleteContractItemParent = item;
      } else if (type === "contract-item") {
        this.deleteContractItemParent = parent;
        this.rejectFormData.objectId = item.id;
      }
      this.dialogTerminate = true;
    },
    async terminateContract() {
      this.showLoading();
      try {
        const { reason, file, contractId, objectId } = this.rejectFormData;
        if (contractId) {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("contractId", contractId);
          formData.append("reason", reason);
          await this.$http.post("contract/reject", formData);
          await this.getContracts();
        } else {
          let formData = {
            objectId,
            reasen: reason,
          };
          await this.$http.delete("contract/delete-item", {
            data: formData,
          });
          this["deleteContractItemParent"].children = this[
            "deleteContractItemParent"
          ].children.filter((item) => {
            return item.id !== objectId;
          });
        }
        this.dialogTerminate = false;
        this.setSuccess({ text: this.$t("successfullyRejected") });
        this["deleteContractItemParent"] = null;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async changePage(page) {
      const { query: initialQuery } = this.$route;
      const { page: queryPage } = initialQuery;
      if (page.toString() !== queryPage) {
        this.showLoading();
        await this.$router.replace({
          query: { ...initialQuery, page: page.toString() },
        });
        await this.getContracts();
        this.clearLoading();
      }
    },
    async getContractsByFilter() {
      this.showLoading();
      this.configuration.page = 1;
      await this.getContracts();
      await this.$router
        .replace({
          query: { ...this.tableOptions, ...this.contractListFilter },
        })
        .catch((err) => {
          console.warn(err);
        });
      this.clearLoading();
    },
    async getContracts() {
      const { page, limit } = this.configuration;
      let params = {
        page: page - 1,
        limit,
        ...this.contractListFilter,
        ...this.tableOptions,
      };
      try {
        const {
          data: { data, total, permissions },
        } = await this.$http.get("contract/office/list", { params });
        this.permissions = permissions;
        this.items = data.map((item) => {
          item.itemsCurrentPage = 1;
          item.itemsPageCount = 0;
          if (item.totalCount)
            item.itemsPageCount = makerPagination({
              limit: ITEM_LIMIT,
              total: +item.totalCount,
            }).lastPage;
          item.loading = false;
          if (!item.aggrementFiles) {
            item.aggrementFiles = [];
          }
          item.show = true;
          item[this.contractChildKey] = item[this.contractChildKey] || [];
          return item;
        });
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async connectWebSocket() {
      try {
        const client = await SocketService.promiseConnect();
        client.subscribe("/user/contract/reply", (data) => {
          data = JSON.parse(data.body);
          if (ozlContractSocketService[data.eventType]) {
            ozlContractSocketService[data.eventType].call(this, data);
          }
        });
      } catch (e) {
        console.log("ws error", e);
      }
    },
  },
  mixins: [gridTableMixin(TABLES.Contract.slug)],
  components: {
    OzlContractItemChangeStatusDialog,
    ContractHistoryDialog,
    OzlContractEditDialog,
    OzlContractDialogView,
    VuePagination,
    BaseCheckbox,
    // VueSelect,
    TableWithFilter,
    OzlNotificationToOmtk,
    OzlContractDocumentDialog,
    ContractFormDialog,
    MultipleDownloader,
    Downloader,
    WarningDialog,
    TriangleBtn,
    OzlChildViewDialog,
    // ConfirmKeyDialog,
  },
  async created() {
    this.showLoading();
    const { query } = this.$route;
    const tableOptions = getQueryByKey(this.tableOptions, query);
    if (tableOptions.sortDirection)
      tableOptions.sortDirection = trueSet(tableOptions.sortDirection);
    if (query.page) {
      this.configuration.page = +query.page;
    }

    this.tableOptions = tableOptions;
    this.contractListFilter = getQueryByKey(FilterOzlOrders, query);

    await Promise.all([this.getContracts(), this.getColumns()]);
    this.clearLoading();
    // await this.connectWebSocket()
  },
  beforeDestroy() {
    // SocketService.disconnect()
  },
};
</script>

<style lang="scss">
#custom__table {
  .header_name_filter_table {
    background-color: #ffffff;
    border-bottom: 1px solid #dde6ef !important;
  }
  .header_filter_table {
    display: none;
  }
  .table_cover tbody tr td {
    border-bottom: 1px solid #dde6ef !important;
    border-top: 1px solid #dde6ef !important;
    border-right: 1px solid #dde6ef !important;
    border: none;
  }
}
</style>
